import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const CityBank = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("city union"))
    .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "Does City Union Bank offer lifetime free credit cards?",
      answer:
        "Some entry-level cards may be lifetime free, while others may have nominal joining and annual fees, with potential for waiver based on annual spending.",
    },
    {
      question: "Can I apply if I don’t have a credit history?",
      answer:
        "Yes. City Union Bank may approve first-time applicants with a strong banking relationship or salary account.",
    },
    {
      question: "Are City Union Bank cards widely accepted?",
      answer:
        "Yes. Most CUB cards are powered by Visa or Rupay, ensuring widespread domestic and limited international acceptance.",
    },
    {
      question: "How are reward points earned and redeemed?",
      answer:
        "Reward points can be earned on retail transactions and redeemed for gift vouchers, utility payments, or merchandise via the bank’s redemption portal.",
    },
    {
      question: "Can I manage the card using CUB mobile banking?",
      answer:
        "Yes. Cardholders can monitor transactions, pay bills, set limits, and block cards using the City Union Bank Mobile Banking App or Internet Banking.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Eligibility",
      description:
        "Confirm your age, income, credit score, and location eligibility criteria as laid out by City Union Bank.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Keep Your Documents Ready",
      description:
        "Collect your ID proof, income documentation, and address proof before starting the application to avoid delays.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Redirect to City Union Bank’s Official Website",
      description:
        "After selecting your preferred card, click “Apply Now” to securely continue your application on the City Union Bank website, where your details will be reviewed and processed directly by the bank.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Browse through our curated list of City Union Bank credit cards on TheFinMaster. Each card is presented with detailed specs on features, charges, benefits, and best use cases to help you select the one that aligns with your lifestyle and spending habits.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Get City Union Bank Credit Card 2024 - Compare & Apply Online at
          TheFinmaster
        </title>
        <meta
          name="description"
          content="City Union Bank Credit Cards - Check all types of City Union Bank credit cards list & their benefits to select the right card for you. Apply for top & best CUB credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="city union bank credit card, cub credit card apply, city union bank credit card benefits, cub credit card eligibility, city union bank credit card rewards"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/city-union-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>

        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Simplified Credit Access Backed by Trust and Traditional Banking
              Values
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              City Union Bank (CUB), one of India’s oldest private sector banks,
              offers credit cards that blend traditional service values with
              modern financial features. Focused on transparency, convenience,
              and accessibility, CUB credit cards are designed for individuals
              seeking reliable and straightforward credit solutions. Whether for
              salaried employees, professionals, or small business owners, these
              cards offer essential benefits without unnecessary complexity.
            </p>
          </div>
        </div>
        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

         <div className="w-full relative ">
                                      <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                        {/* <div className="w-[70%] mx-auto">
                                          <h2 className="text-center font-medium pt-5 text-lg">
                                            <span className="font-semibold text-white">816 people</span>{" "}
                                            are on call with our advisors right now
                                          </h2>
                                        </div> */}
                                        <div className="w-full mx-auto">
                                          <Link to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"     target="_blank"
                              rel="noopener noreferrer">
                                            <div className="w-[80%] mx-auto ">
                                              <img
                                                src="/assets/neoside.png"
                                                alt="Advertisement"
                                             
                                              />
                                            </div>
                                          </Link>
                                          <div className="bg-white">
                                            {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                              Know your advisor
                                            </h3> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>


        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for City Union Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    Applicants must be between 21 and 60 years old. For add-on
                    cards, the minimum age is 18 years.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    A stable monthly income of ₹15,000 or more is preferred for
                    salaried individuals. For self-employed applicants, banking
                    history and annual income are assessed.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    A minimum CIBIL score of 700 is expected for approval.
                    However, the bank may evaluate customers with an existing
                    relationship on a case-by-case basis.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    Both salaried and self-employed individuals are eligible,
                    provided they have consistent income documentation and
                    financial stability.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Geographic Eligibility
                  </span>
                  <span>
                    Availability of credit cards may vary by location. Most
                    approvals are prioritized for customers residing in areas
                    where City Union Bank has a branch presence.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for City Union Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    A valid government-issued ID (Aadhaar, PAN, Passport, or
                    Voter ID) is required for identity verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    Submit documents like Aadhaar, utility bills, rent
                    agreement, or passport for address verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    Salaried: Latest 3 months’ salary slips or Form 16.
                    Self-employed: Most recent ITR, balance sheet, or 6-month
                    bank statement.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Mandatory for KYC and financial profiling as per RBI
                    guidelines.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Recent Photograph
                  </span>
                  <span>
                    A passport-sized photograph must be provided during offline
                    application or KYC verification.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for City Union Bank Credit Card
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CityBank;
